import * as Types from 'src/actions/project/offline-investor/update/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'src/reducers/RootReducer';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import ValidatorService from 'src/services/validation/Validation.service';
import { Validation } from 'src/services/validation/Validator';
import OfflineInvestor from 'src/entities/OfflineInvestor';

export interface UpdateOfflineInvestorAttempt extends Action {
  type: Types.UPDATE_OFFLINE_INVESTOR_ATTEMPT;
}

export interface UpdateOfflineInvestorSuccess extends Action {
  type: Types.UPDATE_OFFLINE_INVESTOR_SUCCESS;
}

export interface UpdateOfflineInvestorFailure extends Action {
  type: Types.UPDATE_OFFLINE_INVESTOR_FAILURE;
  payload: {};
}

export type UpdateOfflineInvestorAction =
  UpdateOfflineInvestorAttempt |
  UpdateOfflineInvestorSuccess |
  UpdateOfflineInvestorFailure;

export interface UpdateOfflineInvestorThunk extends ThunkAction<Promise<UpdateOfflineInvestorAction>, RootState, null> {
}

export const updateOfflineInvestorAttempt: ActionCreator<UpdateOfflineInvestorAttempt> = () => (
  {type: Types.UPDATE_OFFLINE_INVESTOR_ATTEMPT}
);

export const updateOfflineInvestorSuccess: ActionCreator<UpdateOfflineInvestorSuccess> = () => (
  {
    type: Types.UPDATE_OFFLINE_INVESTOR_SUCCESS,
  }
);

export const updateOfflineInvestorFailure: ActionCreator<UpdateOfflineInvestorFailure> = (error: {}) => (
  {
    type: Types.UPDATE_OFFLINE_INVESTOR_FAILURE,
    payload: error
  }
);

export const updateOfflineInvestor: ActionCreator<UpdateOfflineInvestorThunk> = (
  projectId: number, offlineInvestor: OfflineInvestor
): UpdateOfflineInvestorThunk => {

  return (dispatch: Dispatch<RootState>): Promise<UpdateOfflineInvestorAction> => {

    dispatch(updateOfflineInvestorAttempt());

    let restrictions: Validation[] = [
      {value: offlineInvestor.name, message: 'name'},
      {value: offlineInvestor.investmentType, message: 'investmentType'},
      {value: offlineInvestor.amountInvested, type: 'amountInvested'},
    ];

    const validation = ValidatorService.validate(restrictions);

    return validation.then(() => {

      return ApiClient.offlineInvestor.update('', offlineInvestor, {projectId: projectId})
        .then((response: AxiosResponse): UpdateOfflineInvestorSuccess => {
          return dispatch(updateOfflineInvestorSuccess());
        }).catch((e: { response: { data: { errors: {} } } }): UpdateOfflineInvestorFailure => {
          const errorMessages = ValidatorService
            .translateValidations(e && e.response && e.response.data && e.response.data.errors);

          return dispatch(updateOfflineInvestorFailure(errorMessages));
        });
    }).catch((errors) => {
      return dispatch(updateOfflineInvestorFailure(errors));
    });
  };
};



// WEBPACK FOOTER //
// ./src/actions/project/offline-investor/update/UpdateOfflineInvestor.actions.tsx